import { render, staticRenderFns } from "./CampusActivity.vue?vue&type=template&id=5212d7ba&scoped=true&"
import script from "./CampusActivity.vue?vue&type=script&lang=js&"
export * from "./CampusActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5212d7ba",
  null
  
)

export default component.exports